import { cn } from "../../helpers"

const root = (className?: string) =>
  cn("relative h-2 w-full overflow-hidden rounded-full bg-white/40", className)
const indicator = cn("h-full w-full flex-1 rounded-full bg-white transition-all")

export { root, indicator }
